import { useEffect } from 'react';
import { useLocation } from 'wouter';

const ScrollManager = () => {
  const [location] = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: this hook should reset scroll position on every location change
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 0) {
        queueMicrotask(() => {
          window.scrollTo(0, 0);
        });

        // cleanup scroll event listener after the first reset on the new page
        window.removeEventListener('scroll', onScroll);
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [location]);

  return null;
};

export default ScrollManager;
